import React from "react";
import "./SmallCard.css";
import S1 from "../../Assets/img1.png";
import S2 from "../../Assets/img2.png";
import S3 from "../../Assets/img3.png";
import S4 from "../../Assets/img4.png";

function SmallCard() {
  const cards = [
    {
      id: 0,
      img: S1,
      title: "ALL PROJECTS",
    },
    {
      id: 1,
      img: S2,
      title: "APPLICATION STATUS",
    },
    {
      id: 2,
      img: S3,
      title: "ALL RESULTS",
    },
    {
      id: 3,
      img: S4,
      title: "ROLL NO SLIP",
    },
  ];
  return (
    <div className="SM" style={{display:'flex'}}>
      {cards.map((item, index) => {
        return (
          <>
            <div className="SM-main" id="key"  >
              <div className="SM-Top">
                <img className="SM-Img1" src={item.img} alt="" />
              </div>
              <div className="SM-Bottom">
                <button className="SM-btn">{item.title}</button>
              </div>
            </div>
          </>
        );
      })}
    </div>
  );
}

export default SmallCard;
